import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Nav, Navbar } from "rsuite";
// import { Icon } from "@rsuite/icons";
import { Dashboard, BarChart, Page, FileDownload } from "@rsuite/icons";
import Icon from "components/base/Icon";
import styled from "styled-components";
import type { NavItemProps } from "rsuite/esm/Nav/NavItem";

const StyledNav = styled(Nav)`
    && {
        background: none;
        padding: 0;
        margin: 0;
        ${props => props.show ? `
            display: flex;
        ` : `
            display: none;
        `}
        align-items: center;
        justify-content: space-between;
        gap: 0.5rem;
        
    }

    && .rs-nav-item {
        color: #fff;
        font-family: "Lato";
        font-size: 1rem;
        font-weight: 500;
        padding: 0.5rem 1rem;
        transition: background-color 0.2s ease-in-out;

        &:hover {
            background-color: var(--color-hover-bg);
        }
    }
`;



const Navigation: React.FC = () => {
    const location = useLocation();
    const search = location.search;

    const isAuthenticated = !!localStorage.getItem("token");
    const initPath = window.location.pathname || "/calls";
    const [active, setActive] = React.useState(initPath);

    return <StyledNav
        show
        // show={isAuthenticated}
        appearance="pills"
        activeKey={active}
        onSelect={setActive}
    >
        <Nav.Item
            as={Link}
            to={{ pathname: "/calls", search }}
            eventKey="/calls"
            icon={<Icon as={Dashboard} />}
        >
            Calls
        </Nav.Item>
        <Nav.Item
            as={Link}
            to={{ pathname: "/raw-packets", search }}
            eventKey="/raw-packets"
            icon={<Icon as={Page} />}
        >
            Raw Packets
        </Nav.Item>
        <Nav.Item
            as={Link}
            to={{ pathname: "/extracted-dumps", search }}
            eventKey="/extracted-dumps"
            icon={<Icon as={BarChart} />}
        >
            Extracted dumps
        </Nav.Item>
        <Nav.Item
            as={Link}
            to={{ pathname: "/files", search }}
            eventKey="/files"
            icon={<Icon as={FileDownload} />}
        >
            Files
        </Nav.Item>
        {/* <Nav.Item as={Link} to="/logout" eventKey="/logout" icon={<Icon as={Exit} />}>
            Logout
        </Nav.Item> */}
    </StyledNav>;
};

export default Navigation;